import "./styles.less";

import { Button, Empty, Typography } from "antd";
import { K_LISTING_MARKER_SIZE, ListingMarker } from "../../Map/Listing/Marker/web";

import { GoogleMap } from "../../Map/GoogleMap/web";
import { LeafletMapDynamic } from "../../Map/LeafletMap/LeafletMapDynamic/web";
import { PropComponentMode } from "../PropertyInterfaces";
import React, { MouseEvent, MouseEventHandler, useContext, useEffect, useState } from "react";
import { usePropertyMap } from "./hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { ModalPhoneWithoutLogin } from "../ModalPhoneWithoutLogin/web";
import { CountryCode } from "libphonenumber-js";
import { useUser } from "shared-components/Components/User/User.hook";
import { getInitCountryCode } from "../InformationRequest/LeadButtons/PhoneButton/web";
import { getInitialContactForm } from "src/utils/Functions";
import usePropertyData from "src/hooks/propertyData/usePropertyData";

const { Text } = Typography;

export function PropertyMap({
	id,
	defaultZoom = 16,
	width,
	height,
	type = "leaflet",
	options = {},
	onClick = false,
	mode = "auto",
	showSchools = false,
	latitude,
	longitude,
	isProject,
	pointType = false,
}: {
	id: string;
	defaultZoom?: number;
	width: number | string;
	height: number | string;
	type?: "leaflet" | "google";
	options?: object;
	onClick?: CallableFunction | false;
	mode?: PropComponentMode;
	showSchools?: boolean;
	latitude: number | null;
	longitude: number | null;
	isProject: boolean;
	pointType: boolean;
}) {
	const [openDataModal, setOpenDataModal] = useState(false);
	const { isLoggedIn, user } = useUser();
	const [dataModal, setDataModal] = useState({
		name: "",
		phone: "",
		email: "",
		fincatyc: false,
	});
	const {listing} = usePropertyData()

	const [selectedCountryCode, setSelectedCountryCode] = useState<{
		code: CountryCode;
		value: string;
	}>({
		// This code should be a setting, depending the website
		code: "CO",
		value: "+57",
	});

	const handleClick = async e => {
		e.preventDefault();
		const input = {
			name: dataModal.name,
			email: dataModal.email,
			phone: selectedCountryCode.value + dataModal.phone,
		};

		sendLead(input).then(response => {
			setOpenDataModal(false);
			handleClickShowNotification({
				message: response?.success ? "Consulta enviada" : "Error al enviar la consulta",
				type: response?.success ? "success" : "error",
			});
		});
	};

	useEffect(() => {
		setDataModal(getInitialContactForm(isLoggedIn, user?.data));
		setSelectedCountryCode(getInitCountryCode());
	}, []);

	const handleClickShowNotification = async ({
		type = "success",
		message = "",
		description = "",
	}) => {
		const { showNotification } = await import(
			"shared-components/Components/CustomNotification/web"
		);
		showNotification(type, message, description);
	};
	const { loadingSendLead, sendLead } = usePropertyMap({
		id,
		mode,
		isProject,
	});
	const { theme } = useTheme();
	const marker = { latitude, longitude, icon: pointType ? "large" : "" };

	if (!latitude || !longitude)
		return (
			<Empty
				style={{ zIndex: 8 }}
				imageStyle={{ height: 50, opacity: 0.9 }}
				description={
					<Text style={{ color: theme.colors.textInverseColor }}>
						{"La propiedad no tiene ubicación"}
					</Text>
				}>
				<Button
					loading={loadingSendLead}
					disabled={!listing?.active}
					onClick={() => {
						if (!isLoggedIn) {
							setOpenDataModal(true);
							return;
						}
						sendLead().then(response => {
							handleClickShowNotification({
								message: response.success
									? "Consulta enviada"
									: "Error al enviar la consulta",
								type: response.success ? "success" : "error",
							});
						});
					}}
					ghost>
					{"Pedir ubicación"}
				</Button>
				<ModalPhoneWithoutLogin
					open={openDataModal}
					onClose={() => {
						setOpenDataModal(false);
					}}
					isProject
					onSubmit={handleClick}
					formData={dataModal}
					setFormData={setDataModal}
					selectedCountryCode={selectedCountryCode}
					setSelectedCountryCode={setSelectedCountryCode}
				/>
			</Empty>
		);

	/**
	 * tiene q ser display flex, si no se rompe el child height 100%.
	 */

	if (type == "google") {
		return (
			<div
				style={{
					width: width,
					height: height,
					display: "flex",
					cursor: !!onClick ? "pointer" : "default",
				}}
				onClick={x => !!onClick && onClick(x)}>
				<GoogleMap
					height={"100%"}
					width={"100%"}
					defaultZoom={defaultZoom}
					showSchools={showSchools}
					streetView={false}
					center={marker}
					options={{ marker_size: K_LISTING_MARKER_SIZE, ...options }}>
					<ListingMarker
						key={"marker_" + id}
						id={id}
						lat={latitude}
						lng={longitude}
						text={"X"}
						active={false}
						zoomPrecio={false}
						pointType={pointType}
						updateInfoWindowPosition={() => {}}
					/>
				</GoogleMap>
			</div>
		);
	}

	return (
		<div
			style={{
				width: width,
				height: height,
				display: "flex",
				cursor: !!onClick ? "pointer" : "default",
			}}
			onClick={x => !!onClick && onClick(x)}>
			<LeafletMapDynamic
				defaultZoom={defaultZoom}
				center={marker}
				markers={[marker]}
				options={options}
			/>
		</div>
	);
}

